/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useState } from 'react';

import { jsx } from '@compiled/react';
import { useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import { Anchor, Inline } from '@atlaskit/primitives/compiled';

// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import { ThumbnailImage } from '../../../../../../../../common/ui/search-result-thumbnail/thumbnail-image';
// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import { isLoomUrlExpired } from '../is-loom-url-expired';
// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import { messages } from '../messages';

const styles = cssMap({
	thumbnailContainer: {
		position: 'relative',
		gridArea: 'body',
	},
});

interface VideoThumbnailProps {
	thumbnailUrl?: string | null;
	url: string;
}

/**
 * Shared video thumbnail component used by video search results.
 * Displays a thumbnail image with error handling and URL expiration checks.
 */
export const VideoThumbnail: ({ thumbnailUrl, url }: VideoThumbnailProps) => JSX.Element | null = ({
	thumbnailUrl,
	url,
}: VideoThumbnailProps) => {
	const { formatMessage } = useIntl();
	const [isErrored, setIsErrored] = useState(false);

	if (!thumbnailUrl || isLoomUrlExpired(thumbnailUrl) || isErrored) {
		return null;
	}

	return (
		<Inline testId="thumbnail-container" xcss={styles.thumbnailContainer}>
			<Anchor href={url} rel={'noreferrer'} target={'_blank'}>
				<ThumbnailImage
					src={thumbnailUrl}
					alt={formatMessage(messages.videoThumbnailAltText)}
					onError={() => setIsErrored(true)}
				/>
			</Anchor>
		</Inline>
	);
};
